import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {serverLink} from "../../../resources/url";
import DataLoader from "../../common/dataLoader/dataLoader";
import DataTable from "../../common/data-table/data-table";
import DepartmentSelectOption from "../../common/dynamic-select-option/department-select-option";

function AdmittedStudentReport(props) {
    const [IsLoading, setIsLoading] = useState(false)
    const [showTBL, setShowTBL] = useState(false)
    const [settingsList, setSettingsList] = useState([])
    const [studentList, setStudentList] = useState([])
    const header = ["S/N", "STUDENTID", "Name", "Gender", "Programme", "Email Address", "Phone No.", "Admission Year", "Admission Session"];
    const [formData, setFormData] = useState({
        DEPT_ID: "",
        Session: "",
        INSERTED_BY: `${props.loginData[0]?.StaffID}`,
    })

    const getAllData = async () => {
        await axios.get(`${serverLink}staff/registration/academic/settings/list`)
            .then((result) => {
                if (result.data.length > 0) {
                    setSettingsList(result.data);
                }
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        if (formData.Session.toString() !== "" && formData.DEPT_ID.toString() !== "") {
            getData(formData.DEPT_ID, formData.Session);
        }
    }, [formData.DEPT_ID.toString()]);

    useEffect(() => {
        if (formData.Session.toString() !== "" && formData.DEPT_ID.toString() !== "") {
            getData(formData.DEPT_ID, formData.Session);
        }
    }, [formData.Session.toString()]);

    const getData = async (programme, session) => {
        setIsLoading(true)
        await axios.get(`${serverLink}staff/report/registration/student/admitted/${programme}/${btoa(session)}`)
            .then((result) => {
                if (result.data.length > 0) {
                    setStudentList(result.data);
                } else {
                    setStudentList([])
                }
                setIsLoading(false)
                setShowTBL(true)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
                setIsLoading(false)
            });
    }

    const showTable = () => {
        try {
            return studentList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td className="text-xs font-weight-bold">{index + 1}</td>
                        <td className="text-xs font-weight-bold">{item.STUDENTID || "N/A"}</td>
                        <td className="text-xs font-weight-bold">{item.STUDENT_NAME}</td>
                        <td className="text-xs font-weight-bold">{item.GENDER}</td>
                        <td className="text-xs font-weight-bold">{item.PROGRAMME}</td>
                        <td className="text-xs font-weight-bold">{item.EMAIL}</td>
                        <td className="text-xs font-weight-bold">{item.TELEPHONE}</td>
                        <td className="text-xs font-weight-bold">{item.ADMISSION_YEAR}</td>
                        <td className="text-xs font-weight-bold">{item.ADMISSION_SESSION}</td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

    const onEdit = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value,
        });
    }

    return (
        IsLoading ?
            <div className="container-xl" style={{height: '700px'}}>
                <div className="page-header d-print-none">
                    <DataLoader/>
                </div>
            </div>
            :
            <>
                <div className="container-xl">
                    <div className="page-header d-print-none">
                        <div className="row align-items-center">
                            <div className="col">
                                <div className="page-pretitle">
                                </div>
                                <h2 className="page-title">
                                    Admitted Student Report
                                </h2>
                            </div>
                            <div className="col-auto ms-auto d-print-none">

                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-body">
                    <div className="container-xl">
                        <div className="row row-deck row-cards">
                            <div className="col-lg-12">
                                <div className="row row-cards">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="hr-text hr-text-left" style={{padding: '0px', marginTop: '15px', marginBottom: '15px'}}><h5>Select Programme and Session</h5></div>
                                                <div className="form-group mb-3">
                                                    <DepartmentSelectOption formData={formData} setFormData={setFormData} />
                                                </div>
                                                <div className="form-group mb-3 col-md-12">
                                                    <select
                                                        className="form-control form-control-solid"
                                                        name="Session"
                                                        id="Session"
                                                        value={formData.Session}
                                                        onChange={onEdit}
                                                    >
                                                        <option value="">Select Session</option>
                                                        {
                                                            settingsList.sort((a, b) => b.Session - a.Session).map((item, index) => {
                                                                return (<option className={item.Status.toString() === "1" ? "text-success" : ""} key={index} value={item.Session}>{item.Session} {item.Status.toString() === "1" ? " (Active Session)" : ""}</option>)
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                {
                                                    showTBL ?
                                                        <DataTable header={header} body={showTable()} title="Admitted Student Report" />
                                                        :
                                                        <div className="alert alert-important alert-info alert-dismissible" role="alert">
                                                            <div className="d-flex">
                                                                <div>
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                         className="icon alert-icon" width="24"
                                                                         height="24" viewBox="0 0 24 24"
                                                                         strokeWidth="2" stroke="currentColor"
                                                                         fill="none" strokeLinecap="round"
                                                                         strokeLinejoin="round">
                                                                        <path stroke="none" d="M0 0h24v24H0z"
                                                                              fill="none"/>
                                                                        <circle cx="12" cy="12" r="9"/>
                                                                        <line x1="12" y1="8" x2="12.01" y2="8"/>
                                                                        <polyline points="11 12 12 12 12 16 13 16"/>
                                                                    </svg>
                                                                </div>
                                                                <div> Please select Programme and Session to show the Admitted Student Report </div>
                                                            </div>
                                                            <a className="btn-close btn-close-white" data-bs-dismiss="alert" aria-label="close"/>
                                                        </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.loginDetails,
    };
};
export default connect(mapStateToProps, null)(AdmittedStudentReport);
